// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.heroSection {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  text-align: center;
  z-index: 2;
}
.heroSection h3 {
  text-transform: uppercase;
  margin-bottom: 20px;
  padding-top: 9px;
}
.heroSection h1 {
  font-size: 55px;
  font-weight: 700;
}
.heroSection h5 {
  font-size: 15px;
  color: #696c80;
}
.heroSection > button {
  height: 56px;
  width: 194px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.tradingInfo {
  width: 100%;
  position: relative;
  z-index: 2;
  justify-content: center;
}
@media screen and (max-width: 1279px) {
  .tradingInfo {
    flex-wrap: wrap;
  }
}

.quickInfo {
  text-align: center;
  margin: 0 auto 12px;
  width: 100%;
  max-width: 80%;
}
.quickInfo h2 {
  margin-bottom: 60px;
}

.rewardsContainer {
  text-align: center;
  margin-top: 90px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
@media screen and (max-width: 599px) {
  .rewardsContainer {
    margin: 32px 0 64px;
  }
}
.rewardsContainer .allRewardPairs {
  width: 194px;
  height: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 24px;
  background-color: #252833;
  cursor: pointer;
}

.featureHeading {
  margin: auto;
  text-align: center;
}
.featureHeading h3 {
  color: rgba(255, 255, 255, 0.87);
  margin-bottom: 32px;
}

.featureDivider {
  width: 32px;
  height: 2px;
  background: rgba(15, 198, 121, 0.3);
  margin: auto;
}

.featureContainer > div.MuiGrid-root {
  margin-top: 32px;
}
.featureContainer > div.MuiGrid-root > div img {
  width: 150px;
  max-width: 240px;
}
.featureContainer > div.MuiGrid-root > div > div {
  width: calc(100% - 270px);
}
@media screen and (max-width: 599px) {
  .featureContainer > div.MuiGrid-root > div {
    flex-direction: column;
  }
  .featureContainer > div.MuiGrid-root > div img, .featureContainer > div.MuiGrid-root > div > div {
    width: 100%;
    text-align: center;
  }
}
.featureContainer .featureText {
  margin-left: 8px;
}
.featureContainer .featureText h3 {
  color: white;
  margin-bottom: 8;
}

.communityContainer {
  margin: 100px 0;
}
.communityContainer .socialContent {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  margin-top: 48px;
}
.communityContainer .socialContent > div {
  padding: 16px;
  text-align: center;
  width: 120px;
}
.communityContainer .socialContent > div a {
  text-decoration: none;
  color: #c7cad9;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.communityContainer .socialContent > div a:hover {
  color: white;
}
.communityContainer .socialContent > div.svgFill a:hover svg path {
  fill: white;
}
.communityContainer .socialContent > div svg, .communityContainer .socialContent > div img {
  width: 64px;
  height: 64px;
  margin-bottom: 8px;
  filter: grayscale(1);
}
.communityContainer .socialContent > div.svgFill svg path {
  fill: #c7cad9;
}
.communityContainer .socialContent > div.noFill svg, .communityContainer .socialContent > div img {
  opacity: 0.8;
}
.communityContainer .socialContent > div.noFill a:hover svg, .communityContainer .socialContent > div a:hover img {
  opacity: 1;
}

.smallCommunityContainer {
  display: flex;
  align-items: center;
  padding: 0 16px;
  height: 56px;
  position: fixed;
  bottom: 0;
  right: 0;
  border-top-left-radius: 24px;
  background: rgba(27, 32, 43, 0.9);
  -webkit-backdrop-filter: blur(30px);
          backdrop-filter: blur(30px);
  z-index: 11;
}
.smallCommunityContainer a {
  display: flex;
}
.smallCommunityContainer .svgFill svg:hover path {
  fill: #c7cad9;
}
.smallCommunityContainer .svgFill svg path {
  fill: #696c80;
}
.smallCommunityContainer .noFill svg, .smallCommunityContainer img {
  opacity: 0.5;
  filter: grayscale(1);
}
.smallCommunityContainer .noFill svg:hover, .smallCommunityContainer img:hover {
  opacity: 1;
}
.smallCommunityContainer svg, .smallCommunityContainer img {
  width: 32px;
  height: 32px;
  cursor: pointer;
}
@media screen and (max-width: 959px) {
  .smallCommunityContainer {
    display: none;
  }
}

.swapContainer {
  text-align: center;
  padding: 20px 0;
  max-width: 1048px;
  margin: auto;
  width: 100%;
}
.swapContainer > div {
  width: 100%;
}
@media screen and (max-width: 599px) {
  .swapContainer .MuiGrid-item {
    width: 100%;
    margin-bottom: 32px;
    text-align: center;
  }
}

.swapInfo {
  text-align: left;
  margin-bottom: 60px;
}
@media screen and (max-width: 959px) {
  .swapInfo {
    order: -1;
  }
}
.swapInfo h3 {
  margin-bottom: 16px;
}

.tradingSection {
  background: #12131a;
  width: calc(25% - 24px);
  max-width: 288px;
  min-width: 220px;
  height: 133px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  border-radius: 20px;
  margin: 12px;
}
.tradingSection h6 {
  padding-top: 2px;
}
.tradingSection p {
  font-size: 12px;
  color: #696c80;
  padding-top: 12px;
}
.tradingSection h4 {
  font-size: 12px;
  cursor: pointer;
  margin-top: 3px;
  color: #448aff;
}
@media screen and (max-width: 599px) {
  .tradingSection {
    height: auto;
    height: initial;
  }
}

.buyFiatContainer {
  background: #1b1e29;
  padding: 40px;
  border-radius: 48px;
  overflow: hidden;
  position: relative;
}
@media screen and (max-width: 959px) {
  .buyFiatContainer {
    height: auto;
  }
}
@media screen and (max-width: 599px) {
  .buyFiatContainer {
    padding: 24px;
    border-radius: 24px;
  }
}
.buyFiatContainer > img {
  position: absolute;
  top: 0;
  left: 0;
  width: 1248px;
}
.buyFiatContainer > div {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100%;
  position: relative;
  z-index: 2;
}
.buyFiatContainer > div img {
  width: 129px;
  max-width: 320px;
}
@media screen and (max-width: 599px) {
  .buyFiatContainer > div {
    flex-direction: column;
    padding: 0;
  }
}
.buyFiatContainer .buyFiatInfo {
  position: relative;
  margin-right: 20px;
}
.buyFiatContainer .buyFiatInfo > h3 {
  font-size: 22px;
  margin-bottom: 12px;
}
@media screen and (max-width: 599px) {
  .buyFiatContainer .buyFiatInfo {
    flex-direction: column;
    margin-right: 0;
    margin-bottom: 32px;
  }
  .buyFiatContainer .buyFiatInfo img, .buyFiatContainer .buyFiatInfo > div {
    width: 100%;
  }
  .buyFiatContainer .buyFiatInfo img {
    margin: -32px 0;
  }
  .buyFiatContainer .buyFiatInfo div {
    padding: 0 20px 20px;
  }
  .buyFiatContainer .buyFiatInfo button {
    width: 100%;
  }
}
.buyFiatContainer .buyFiatInfo button {
  margin-top: 24px;
  height: 40px;
  border-radius: 20px;
  padding: 0 20px;
}
.buyFiatContainer .buyFiatInfo button small {
  font-size: 16px;
}
.buyFiatContainer .buyFiatWrapper {
  width: 408px;
  position: relative;
}
@media screen and (max-width: 959px) {
  .buyFiatContainer .buyFiatWrapper {
    width: calc(100% - 64px);
    margin-bottom: 32px;
  }
}
@media screen and (max-width: 599px) {
  .buyFiatContainer .buyFiatWrapper {
    width: calc(100% - 40px);
  }
}
.buyFiatContainer .buyFiatWrapper .buyContent {
  background: #12131a;
  border-radius: 20px;
  padding: 24px;
}
.buyFiatContainer .buyFiatWrapper .buyContent > div {
  padding: 0;
  border: none;
  background: transparent;
}
.buyFiatContainer .buyFiatWrapper .buyContent > div > p {
  margin-bottom: 8px;
}
.buyFiatContainer .poweredBySection {
  position: absolute;
  bottom: 16px;
  right: 16px;
  height: auto;
  font-size: 12px;
  font-weight: 600;
  color: #696c80;
}
.buyFiatContainer .poweredBySection img {
  height: 20px;
  width: auto;
}
.buyFiatContainer .poweredBySection img.meldLogo {
  height: 15px;
  margin: 0 3px 0 6px;
}

.newsletterSignupWrapper {
  max-width: 1036px;
  border-radius: 21px;
  background-color: #1b1e29;
  margin: 0 auto;
  position: relative;
  padding: 32px;
  display: flex;
  align-items: center;
}
.newsletterSignupWrapper img {
  position: absolute;
  bottom: 0;
  right: 0;
  opacity: 0.4;
}
@media screen and (max-width: 959px) {
  .newsletterSignupWrapper {
    flex-direction: column;
  }
  .newsletterSignupWrapper > div:first-child {
    text-align: center;
  }
}
@media screen and (max-width: 599px) {
  .newsletterSignupWrapper {
    padding: 24px;
  }
}

.newsletterSignupFormWrapper {
  margin: 0 60px 0 32px;
}

.newsletterSignupForm {
  border: 1px solid rgba(255, 255, 255, 0.47);
  background-color: #12131a;
  display: flex;
  padding: 6px;
  border-radius: 11px;
  position: relative;
  z-index: 5;
}
.newsletterSignupForm input {
  background-color: transparent;
  border: none;
  outline: none;
  box-shadow: none;
  flex: 1 1;
  color: white;
  width: 290px;
  margin-right: 6px;
}
.newsletterSignupForm button {
  background: linear-gradient(90deg, #4a47dc 0%, #a55ed1 100%);
  width: 123px;
  height: 40px;
}
.newsletterSignupForm button span {
  font-size: 14px;
  font-weight: 500;
}
@media screen and (max-width: 959px) {
  .newsletterSignupForm {
    margin: 16px 0 0;
    width: 100%;
    max-width: 430px;
  }
  .newsletterSignupForm input {
    width: auto;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/styles/landing.scss","webpack://./src/styles/_variables.scss","webpack://./src/styles/_breakpoints.scss"],"names":[],"mappings":"AAGA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;AAFF;AAGE;EACE,yBAAA;EACA,mBAAA;EACA,gBAAA;AADJ;AAGE;EACE,eAAA;EACA,gBAAA;AADJ;AAGE;EACE,eAAA;EACA,cCbY;ADYhB;AAGE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AADJ;;AAKA;EACE,WAAA;EACA,kBAAA;EACA,UAAA;EACA,uBAAA;AAFF;AEsLE;EFxLF;IAMI,eAAA;EAAF;AACF;;AAEA;EACE,kBAAA;EACA,mBAAA;EACA,WAAA;EACA,cAAA;AACF;AAAE;EACE,mBAAA;AAEJ;;AACA;EACE,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAEF;AE+JE;EFtKF;IAOI,mBAAA;EAIF;AACF;AAHE;EACE,YAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,yBC9DS;ED+DT,eAAA;AAKJ;;AAFA;EACE,YAAA;EACA,kBAAA;AAKF;AAJE;EACE,gCCtDI;EDuDJ,mBAAA;AAMJ;;AAHA;EACE,WAAA;EACA,WAAA;EACA,mCCzBa;ED0Bb,YAAA;AAMF;;AAHE;EACE,gBAAA;AAMJ;AAJM;EACE,YAAA;EACA,gBAAA;AAMR;AAJM;EACE,yBAAA;AAMR;AEqHE;EFjIE;IASI,sBAAA;EAON;EANM;IAEE,WAAA;IACA,kBAAA;EAOR;AACF;AAHE;EACE,gBAAA;AAKJ;AAJI;EACE,YAAA;EACA,gBAAA;AAMN;;AAFA;EACE,eAAA;AAKF;AAJE;EACE,aAAA;EACA,eAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;AAMJ;AALI;EACE,aAAA;EACA,kBAAA;EACA,YAAA;AAON;AANM;EACE,qBAAA;EACA,cCxHM;EDyHN,aAAA;EACA,sBAAA;EACA,mBAAA;AAQR;AAPQ;EACE,YAAA;AASV;AANM;EACE,WAAA;AAQR;AANM;EAEE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,oBAAA;AAOR;AALM;EACE,aC3IM;ADkJd;AALM;EAEE,YAAA;AAMR;AAJM;EAEE,UAAA;AAKR;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,eAAA;EACA,YAAA;EACA,eAAA;EACA,SAAA;EACA,QAAA;EACA,4BAAA;EACA,iCCnJM;EDoJN,mCAAA;UAAA,2BAAA;EACA,WAAA;AAGF;AAFE;EACE,aAAA;AAIJ;AADI;EACE,aCzKQ;AD4Kd;AADI;EACE,aC3KU;AD8KhB;AAAE;EAEE,YAAA;EACA,oBAAA;AACJ;AAAI;EACE,UAAA;AAEN;AACE;EAEE,WAAA;EACA,YAAA;EACA,eAAA;AAAJ;AEsBE;EFzDF;IAsCI,aAAA;EACF;AACF;;AAEA;EACE,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,WAAA;AACF;AAAE;EACE,WAAA;AAEJ;AEME;EFLE;IACE,WAAA;IACA,mBAAA;IACA,kBAAA;EAEJ;AACF;;AAEA;EACE,gBAAA;EACA,mBAAA;AACF;AENE;EFGF;IAII,SAAA;EAGF;AACF;AAFE;EACE,mBAAA;AAIJ;;AAAA;EACE,mBC5NQ;ED6NR,uBAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;EACA,YAAA;AAGF;AAFE;EACE,gBAAA;AAIJ;AAFE;EACE,eAAA;EACA,cC/OY;EDgPZ,iBAAA;AAIJ;AAFE;EACE,eAAA;EACA,eAAA;EACA,eAAA;EACA,cC9PM;ADkQV;AE1CE;EFcF;IA2BI,YAAA;IAAA,eAAA;EAKF;AACF;;AAFA;EACE,mBC1PU;ED2PV,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AAKF;AEvDE;EF6CF;IAOI,YAAA;EAOF;AACF;AE5DE;EF6CF;IAUI,aAAA;IACA,mBAAA;EASF;AACF;AARE;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,aAAA;AAUJ;AARE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;AAUJ;AATI;EACE,YAAA;EACA,gBAAA;AAWN;AEpFE;EFgEA;IAYI,sBAAA;IACA,UAAA;EAYJ;AACF;AAVE;EACE,kBAAA;EACA,kBAAA;AAYJ;AAXI;EACE,eAAA;EACA,mBAAA;AAaN;AElGE;EFgFA;IAQI,sBAAA;IACA,eAAA;IACA,mBAAA;EAcJ;EAbI;IAEE,WAAA;EAcN;EAZI;IACE,eAAA;EAcN;EAZI;IACE,oBAAA;EAcN;EAZI;IACE,WAAA;EAcN;AACF;AAZI;EACE,gBAAA;EACA,YAAA;EACA,mBAAA;EACA,eAAA;AAcN;AAbM;EACE,eAAA;AAeR;AAXE;EACE,YAAA;EACA,kBAAA;AAaJ;AElIE;EFmHA;IAII,wBAAA;IACA,mBAAA;EAeJ;AACF;AExIE;EFmHA;IAQI,wBAAA;EAiBJ;AACF;AAhBI;EACE,mBC3UI;ED4UJ,mBAAA;EACA,aAAA;AAkBN;AAjBM;EACE,UAAA;EACA,YAAA;EACA,uBAAA;AAmBR;AAlBQ;EACE,kBAAA;AAoBV;AAfE;EACE,kBAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,cClWY;ADmXhB;AAhBI;EACE,YAAA;EACA,WAAA;AAkBN;AAjBM;EACE,YAAA;EACA,mBAAA;AAmBR;;AAbA;EACE,iBAAA;EACA,mBAAA;EACA,yBC7WU;ED8WV,cAAA;EACA,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;AAgBF;AAfE;EACE,kBAAA;EACA,SAAA;EACA,QAAA;EACA,YAAA;AAiBJ;AE5LE;EF8JF;IAgBI,sBAAA;EAkBF;EAjBE;IACE,kBAAA;EAmBJ;AACF;AEpME;EF8JF;IAsBI,aAAA;EAoBF;AACF;;AAjBA;EACE,qBAAA;AAoBF;;AAjBA;EACE,2CAAA;EACA,yBC3YQ;ED4YR,aAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,UAAA;AAoBF;AAnBE;EACE,6BAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,SAAA;EACA,YAAA;EACA,YAAA;EACA,iBAAA;AAqBJ;AAnBE;EACE,4DAAA;EACA,YAAA;EACA,YAAA;AAqBJ;AApBI;EACE,eAAA;EACA,gBAAA;AAsBN;AE1OE;EF4LF;IA4BI,gBAAA;IACA,WAAA;IACA,gBAAA;EAsBF;EArBE;IACE,WAAA;EAuBJ;AACF","sourcesContent":["@use 'styles/variables' as *;\n@use 'styles/breakpoints' as *;\n\n.heroSection {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  text-align: center;\n  z-index: 2;\n  & h3 {\n    text-transform: uppercase;\n    margin-bottom: 20px;\n    padding-top: 9px;\n  }\n  & h1 {\n    font-size: 55px;\n    font-weight: 700;\n  }\n  & h5 {\n    font-size: 15px;\n    color: $textSecondary;\n  }\n  & > button {\n    height: 56px;\n    width: 194px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n}\n\n.tradingInfo {\n  width: 100%;\n  position: relative;\n  z-index: 2;\n  justify-content: center;\n  @include media('screen', '<desktop') {\n    flex-wrap: wrap;\n  }\n}\n.quickInfo {\n  text-align: center;\n  margin: 0 auto 12px;\n  width: 100%;\n  max-width: 80%;\n  & h2 {\n    margin-bottom: 60px;\n  }\n}\n.rewardsContainer {\n  text-align: center;\n  margin-top: 90px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  @include media('screen', '<phone') {\n    margin: 32px 0 64px;\n  }\n  .allRewardPairs {\n    width: 194px;\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 24px;\n    background-color: $secondary1;\n    cursor: pointer;\n  }\n}\n.featureHeading {\n  margin: auto;\n  text-align: center;\n  & h3 {\n    color: $grey7;\n    margin-bottom: 32px;\n  }\n}\n.featureDivider {\n  width: 32px;\n  height: 2px;\n  background: $successLight;\n  margin: auto;\n}\n.featureContainer {\n  & > div.MuiGrid-root {\n    margin-top: 32px;\n    & > div {\n      & img {\n        width: 150px;\n        max-width: 240px;\n      }\n      & > div {\n        width: calc(100% - 270px);\n      }\n      @include media('screen', '<phone') {\n        flex-direction: column;\n        & img,\n        & > div {\n          width: 100%;\n          text-align: center;\n        }\n      }\n    }\n  }\n  & .featureText {\n    margin-left: 8px;\n    & h3 {\n      color: white;\n      margin-bottom: 8;\n    }\n  }\n}\n.communityContainer {\n  margin: 100px 0;\n  & .socialContent {\n    display: flex;\n    flex-wrap: wrap;\n    align-items: center;\n    justify-content: center;\n    margin-top: 48px;\n    & > div {\n      padding: 16px;\n      text-align: center;\n      width: 120px;\n      & a {\n        text-decoration: none;\n        color: $textPrimary;\n        display: flex;\n        flex-direction: column;\n        align-items: center;\n        &:hover {\n          color: white;\n        }\n      }\n      &.svgFill a:hover svg path {\n        fill: white;\n      }\n      & svg,\n      & img {\n        width: 64px;\n        height: 64px;\n        margin-bottom: 8px;\n        filter: grayscale(1);\n      }\n      &.svgFill svg path {\n        fill: $textPrimary;\n      }\n      &.noFill svg,\n      & img {\n        opacity: 0.8;\n      }\n      &.noFill a:hover svg,\n      & a:hover img {\n        opacity: 1;\n      }\n    }\n  }\n}\n.smallCommunityContainer {\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  height: 56px;\n  position: fixed;\n  bottom: 0;\n  right: 0;\n  border-top-left-radius: 24px;\n  background: $grey8;\n  backdrop-filter: blur(30px);\n  z-index: 11;\n  & a {\n    display: flex;\n  }\n  & .svgFill svg {\n    &:hover path {\n      fill: $textPrimary;\n    }\n    & path {\n      fill: $textSecondary;\n    }\n  }\n  & .noFill svg,\n  & img {\n    opacity: 0.5;\n    filter: grayscale(1);\n    &:hover {\n      opacity: 1;\n    }\n  }\n  & svg,\n  & img {\n    width: 32px;\n    height: 32px;\n    cursor: pointer;\n  }\n  @include media('screen', '<tablet') {\n    display: none;\n  }\n}\n\n.swapContainer {\n  text-align: center;\n  padding: 20px 0;\n  max-width: 1048px;\n  margin: auto;\n  width: 100%;\n  & > div {\n    width: 100%;\n  }\n  @include media('screen', '<phone') {\n    & .MuiGrid-item {\n      width: 100%;\n      margin-bottom: 32px;\n      text-align: center;\n    }\n  }\n}\n\n.swapInfo {\n  text-align: left;\n  margin-bottom: 60px;\n  @include media('screen', '<tablet') {\n    order: -1;\n  }\n  & h3 {\n    margin-bottom: 16px;\n  }\n}\n\n.tradingSection {\n  background: $bgColor;\n  width: calc(25% - 24px);\n  max-width: 288px;\n  min-width: 220px;\n  height: 133px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  border-radius: 20px;\n  margin: 12px;\n  & h6 {\n    padding-top: 2px;\n  }\n  & p {\n    font-size: 12px;\n    color: $textSecondary;\n    padding-top: 12px;\n  }\n  & h4 {\n    font-size: 12px;\n    cursor: pointer;\n    margin-top: 3px;\n    color: $primary;\n  }\n  @include media('screen', '<phone') {\n    height: unset;\n  }\n}\n\n.buyFiatContainer {\n  background: $bgPalette;\n  padding: 40px;\n  border-radius: 48px;\n  overflow: hidden;\n  position: relative;\n  @include media('screen', '<tablet') {\n    height: auto;\n  }\n  @include media('screen', '<phone') {\n    padding: 24px;\n    border-radius: 24px;\n  }\n  & > img {\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 1248px;\n  }\n  & > div {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    height: 100%;\n    position: relative;\n    z-index: 2;\n    & img {\n      width: 129px;\n      max-width: 320px;\n    }\n    @include media('screen', '<phone') {\n      flex-direction: column;\n      padding: 0;\n    }\n  }\n  & .buyFiatInfo {\n    position: relative;\n    margin-right: 20px;\n    & > h3 {\n      font-size: 22px;\n      margin-bottom: 12px;\n    }\n    @include media('screen', '<phone') {\n      flex-direction: column;\n      margin-right: 0;\n      margin-bottom: 32px;\n      & img,\n      & > div {\n        width: 100%;\n      }\n      & img {\n        margin: -32px 0;\n      }\n      & div {\n        padding: 0 20px 20px;\n      }\n      & button {\n        width: 100%;\n      }\n    }\n    & button {\n      margin-top: 24px;\n      height: 40px;\n      border-radius: 20px;\n      padding: 0 20px;\n      & small {\n        font-size: 16px;\n      }\n    }\n  }\n  & .buyFiatWrapper {\n    width: 408px;\n    position: relative;\n    @include media('screen', '<tablet') {\n      width: calc(100% - 64px);\n      margin-bottom: 32px;\n    }\n    @include media('screen', '<phone') {\n      width: calc(100% - 40px);\n    }\n    & .buyContent {\n      background: $bgColor;\n      border-radius: 20px;\n      padding: 24px;\n      & > div {\n        padding: 0;\n        border: none;\n        background: transparent;\n        & > p {\n          margin-bottom: 8px;\n        }\n      }\n    }\n  }\n  .poweredBySection {\n    position: absolute;\n    bottom: 16px;\n    right: 16px;\n    height: auto;\n    font-size: 12px;\n    font-weight: 600;\n    color: $textSecondary;\n    & img {\n      height: 20px;\n      width: auto;\n      &.meldLogo {\n        height: 15px;\n        margin: 0 3px 0 6px;\n      }\n    }\n  }\n}\n\n.newsletterSignupWrapper {\n  max-width: 1036px;\n  border-radius: 21px;\n  background-color: $bgPalette;\n  margin: 0 auto;\n  position: relative;\n  padding: 32px;\n  display: flex;\n  align-items: center;\n  & img {\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    opacity: 0.4;\n  }\n  @include media('screen', '<tablet') {\n    flex-direction: column;\n    & > div:first-child {\n      text-align: center;\n    }\n  }\n  @include media('screen', '<phone') {\n    padding: 24px;\n  }\n}\n\n.newsletterSignupFormWrapper {\n  margin: 0 60px 0 32px;\n}\n\n.newsletterSignupForm {\n  border: 1px solid $grey22;\n  background-color: $bgColor;\n  display: flex;\n  padding: 6px;\n  border-radius: 11px;\n  position: relative;\n  z-index: 5;\n  & input {\n    background-color: transparent;\n    border: none;\n    outline: none;\n    box-shadow: none;\n    flex: 1;\n    color: white;\n    width: 290px;\n    margin-right: 6px;\n  }\n  & button {\n    background: linear-gradient(90deg, $blue9 0%, $purple3 100%);\n    width: 123px;\n    height: 40px;\n    & span {\n      font-size: 14px;\n      font-weight: 500;\n    }\n  }\n  @include media('screen', '<tablet') {\n    margin: 16px 0 0;\n    width: 100%;\n    max-width: 430px;\n    & input {\n      width: auto;\n    }\n  }\n}\n","$primary: #448aff;\n$primaryLight: rgba(68, 138, 255, 0.3);\n$primaryDark: #1c2938;\n$secondary: #344252;\n$secondary1: #252833;\n$secondary2: #232734;\n$secondary3: #2c3242;\n$textPrimary: #c7cad9;\n$textSecondary: #696c80;\n$textDisabled: #626680;\n$textHint: #636780;\n$bgColor: #12131a;\n$bgPalette: #1b1e29;\n$bgPalette1: rgba(29, 30, 50, 0.9);\n$grey1: rgba(99, 103, 128, 0.1);\n$grey2: #3e4252;\n$grey3: #1b1d26;\n$grey4: rgba(68, 138, 255, 0.24);\n$grey5: rgba(225, 190, 231, 0.1);\n$grey6: #c5cbe0;\n$grey7: rgba(255, 255, 255, 0.87);\n$grey8: rgb(27, 32, 43, 0.9);\n$grey9: rgb(43, 45, 59, 0.2);\n$grey10: #1d212c;\n$grey11: rgba(40, 145, 249, 0.1);\n$grey12: #404557;\n$grey13: rgba(0, 0, 0, 0.075);\n$grey14: rgba(105, 108, 128, 0.12);\n$grey15: rgba(27, 30, 41, 0);\n$grey16: rgba(0, 0, 0, 0.01);\n$grey17: rgba(0, 0, 0, 0.04);\n$grey18: #999;\n$grey19: #b6b9cc;\n$grey20: #b4c2d5;\n$grey21: rgba(0, 0, 0, 0.15);\n$grey22: rgba(255, 255, 255, 0.47);\n$grey23: rgba(212, 229, 255, 0.8);\n$grey24: rgba(15, 198, 121, 0.2);\n$grey25: rgb(199, 202, 217);\n$grey26: #444444;\n$grey27: #2c3142;\n$grey28: #2d3447;\n$grey29: #282d3e;\n$grey30: rgba(105, 108, 128, 0.3);\n$grey31: rgba(40, 45, 61, 0.5);\n$grey32: #ebecf2;\n$grey33: #13151c;\n$grey34: rgba(255, 255, 255, 0.2);\n$grey35: #afb2ba;\n$grey36: rgba(40, 45, 61, 0.84);\n$grey37: rgba(199, 202, 217, 0.16);\n$grey38: rgba(255, 255, 255, 0.08);\n$grey39: rgba(30, 38, 61, 0.5);\n$grey40: rgba(30, 38, 61, 0.32);\n$successMain: #0fc679;\n$successDark: #1db2d5;\n$successLight: rgba(15, 198, 121, 0.3);\n$errorMain: #ff5252;\n$errorDark: #f00;\n$errorLight: rgba(255, 82, 82, 0.1);\n$divider: rgba(130, 177, 255, 0.08);\n$blue: #3d71ff;\n$blue1: #004ce6;\n$blue2: #0098ff;\n$blue3: #00cff3;\n$blue4: #5294ff;\n$blue5: #4389fd;\n$blue6: rgba(68, 138, 255, 0.3);\n$blue7: rgba(68, 138, 255, 0.5);\n$blue8: #353c71;\n$blue9: #4a47dc;\n$blue10: #5469d6;\n$blue11: #2e4ec2;\n$blue12: #b0dcfc;\n$green1: #64fbd3;\n$green2: rgba(15, 198, 121, 0.12);\n$green3: #33ce4b;\n$green4: #7addcb;\n$yellow1: #e59840;\n$yellow2: rgba(255, 160, 0, 0.3);\n$yellow3: #ffa000;\n$yellow4: #4b3625;\n$yellow5: #fdd835;\n$purple: #7c4dff;\n$yellow6: #ffa726;\n$yellow7: rgba(255, 167, 38, 0.3);\n$yellow8: rgba(235, 147, 47, 0.16);\n$yellow9: #eb932f;\n$purple1: #3f2d66;\n$purple2: #594090;\n$purple3: #a55ed1;\n$purple4: #b063fd;\n$purple5: rgba(77, 87, 178, 0.35);\n$purple6: #7732e7;\n$purple7: rgba(77, 74, 253, 0.57);\n$purple8: #beaffd;\n$black1: #1b1e29;\n$black2: #111f44;\n$black3: rgba(0, 0, 0, 0.8);\n$lightBlue: #b4d0ff;\n","$breakpoints: (\n  'phone': 600px, \n  'tablet': 960px, \n  'desktop': 1280px,\n) !default;\n\n$media-expressions: (\n  'screen': 'screen', \n  'print': 'print', \n  'handheld': 'handheld',\n  'retina2x': (\n    '(-webkit-min-device-pixel-ratio: 2)', \n    '(min-resolution: 192dpi)'\n  ), \n  'retina3x': (\n    '(-webkit-min-device-pixel-ratio: 3)', \n    '(min-resolution: 350dpi)'\n  )\n) !default;\n\n$unit-intervals: (\n  'px': 1, \n  'em': 0.01, \n  'rem': 0.1\n) !default;\n\n@function to-number($string) {\n  // Matrices\n  $strings: '0' '1' '2' '3' '4' '5' '6' '7' '8' '9';\n  $numbers:  0   1   2   3   4   5   6   7   8   9;\n  \n  // Result\n  $result: 0;\n  $divider: 0;\n  $minus: false;\n\n  // Looping through all characters\n  @for $i from 1 through str-length($string) {\n    $character: str-slice($string, $i, $i);\n    $index: index($strings, $character);\n    \n  \n    @if $character == '-' {\n      $minus: true;\n    }\n    \n    @else if $character == '.' {\n      $divider: 1;\n    }\n    \n    @else {\n      @if type-of($index) != 'number' {\n        $result: if($minus, $result * -1, $result);\n        @return _length($result, str-slice($string, $i));\n      }\n\n      $number: nth($numbers, $index);\n      \n      @if $divider == 0 {\n        $result: $result * 10;\n      }\n      \n      @else {\n        // Move the decimal dot to the left\n        $divider: $divider * 10;\n        $number: $number / $divider;\n      }\n      \n      $result: $result + $number;\n    }\n  }\n  \n  @return if($minus, $result * -1, $result);\n}\n\n@function _length($number, $unit) {\n  $strings: 'px' 'cm' 'mm' '%' 'ch' 'pica' 'in' 'em' 'rem' 'pt' 'pc' 'ex' 'vw' 'vh' 'vmin' 'vmax';\n  $units:   1px  1cm  1mm  1%  1ch  1pica  1in  1em  1rem  1pt  1pc  1ex  1vw  1vh  1vmin  1vmax;\n  $index: index($strings, $unit);\n  \n  @if type-of($index) != 'number' {\n    @warn 'Unknown unit `#{$unit}`.';\n    @return false;\n  }\n  \n  @return $number * nth($units, $index);\n}\n\n@function parse-expression($expression) {\n  $operator: '';\n  $value: '';\n  $element: '';\n  $result: '';\n  $is-width: true;\n\n  @if (type-of($expression) != 'string') {\n    @warn 'Expression with type `#{type-of($expression)}` detected, string expected.';\n  }\n\n  // Separating the operator from the rest of the expression\n  @if (str-slice($expression, 2, 2) == '=') {\n    $operator: str-slice($expression, 1, 2);\n    $value: str-slice($expression, 3);\n  } @else {\n    $operator: str-slice($expression, 1, 1);\n    $value: str-slice($expression, 2);\n  }\n\n  // Checking what type of expression we're dealing with\n  @if map-has-key($breakpoints, $value) {\n    $result: map-get($breakpoints, $value);\n  } @else if map-has-key($media-expressions, $expression) {\n    $result: map-get($media-expressions, $expression);\n    $is-width: false;\n  } @else {\n    $result: to-number($value);\n  }\n\n  @if ($is-width) {\n    $unit: unit($result);\n    $interval: 0;\n    \n    @if (map-has-key($unit-intervals, $unit)) {\n      $interval: map-get($unit-intervals, $unit);\n    } @else {\n      @warn 'Unknown unit: #{$unit}';\n    } \n       \n    @if ($operator == '>') {\n      $element: '(min-width: #{$result + $interval})';\n    } @else if ($operator == '<') {\n      $element: '(max-width: #{$result - $interval})';\n    } @else if ($operator == '>=') {\n      $element: '(min-width: #{$result})';\n    } @else if ($operator == '<=') {\n      $element: '(max-width: #{$result})';\n    } @else {\n      @warn '#{$expression} is missing an operator.';\n    }\n  } @else {\n    $element: $result;\n  }\n\n  @return $element;\n}\n\n@function str-replace-first($search, $replace, $subject) {\n  $search-start: str-index($subject, $search);\n\n  @if $search-start == null {\n    @return $subject;\n  }\n\n  $result: str-slice($subject, 0, $search-start - 1);\n  $result: $result + $replace;\n  $result: $result + str-slice($subject, $search-start + str-length($search));\n\n  @return $result;\n}\n\n@function get-query-branches($expressions) {\n  $result: '';\n  $has-groups: false;\n\n  // Getting initial snapshot and looking for groups\n  @each $expression in $expressions {\n    @if (str-length($result) != 0) {\n      $result: $result + ' and ';\n    }\n\n    @if (type-of($expression) == 'string') {\n      $result: $result + $expression;\n    } @else if (type-of($expression) == 'list') {\n      $result: $result + nth($expression, 1);\n      $has-groups: true;\n    } @else {\n      @warn '#{$expression} is not a valid expression.';\n    }\n  }\n\n  // If we have groups, we have to create all possible combinations\n  @if $has-groups {\n    @each $expression in $expressions {\n      @if (type-of($expression) == 'list') {\n        $first: nth($expression, 1);\n\n        @each $member in $expression {\n          @if ($member != $first) {\n            @each $partial in $result {\n              $result: join($result, str-replace-first($first, $member, $partial));\n            }\n          }\n        }\n      }\n    }\n  }\n\n  @return $result;\n}\n\n@mixin media($conditions...) {\n  @for $i from 1 through length($conditions) {\n    $conditions: set-nth($conditions, $i, parse-expression(nth($conditions, $i)));\n  }\n\n  $branches: get-query-branches($conditions);\n  $query: '';\n\n  @each $branch in $branches {\n    @if (str-length($query) != 0) {\n      $query: $query + ', ';\n    }\n\n    $query: $query + $branch;\n  }\n\n  @media #{$query} {\n    @content;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
